import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/cms/module-container'
import {Box, Text, useSlotRecipe} from '@chakra-ui/react3'
import awardsSlotRecipe from './index.recipe'
import Image from '../../components/cms/image'
import Heading from '../../components/cms/heading'
import TypewrighterAnimation from '../../components/cms/typewriterAnimation'

const Awards = React.forwardRef(
    (
        {
            moduleId,
            moduleType,
            pageId,
            anchor,
            headingLevel,
            heading,
            copy,
            background,
            images,
            spacing
        },
        ref
    ) => {
        const recipe = useSlotRecipe({recipe: awardsSlotRecipe})
        const styles = useMemo(() => recipe(), [recipe])

        return (
            <ModuleContainer
                moduleId={moduleId}
                moduleType={moduleType}
                pageId={pageId}
                anchor={anchor}
                background={background}
                css={styles.root}
                spacing={spacing}
                ref={ref}
            >
                <Heading
                    {...heading}
                    variant="awards"
                    headingLevel={headingLevel}
                    alignment="center"
                ></Heading>
                <TypewrighterAnimation
                    from={'text.secondary'}
                    to={'text.primary'}
                    css={styles.copy}
                >
                    {copy.text}
                </TypewrighterAnimation>
                {images?.length > 0 && (
                    <Box css={styles.awardsGroup}>
                        {images.map((el, index) => (
                            <Box key={index} css={styles.award}>
                                <Image
                                    {...el}
                                    {...styles.awardImage}
                                    widths={{
                                        base: '108px',
                                        s: '139px'
                                    }}
                                ></Image>
                                <Text css={styles.awardText}>{el.title}</Text>
                            </Box>
                        ))}
                    </Box>
                )}
            </ModuleContainer>
        )
    }
)

if (process.env.NODE_ENV !== 'production') {
    Awards.displayName = 'Awards'
}

Awards.propTypes = {
    anchor: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    copy: PropTypes.object,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    images: PropTypes.array,
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default Awards
